import React, { useEffect, useState } from "react"
import cx from "classnames"
import Link from "gatsby-link"
import { StaticImage } from "gatsby-plugin-image"

import { Accordion, Item } from "../../components"
import { Detail, Link as LinkButton } from "../../elements"
import { Hamburger, Triangle } from "../../identity"

type Props = {
  className?: string
}

function Header({ className }: Props) {
  let [state, setState] = useState({
    desktopOverlayIsOpen: false,
    mobileOverlayIsOpen: false,
  })

  useEffect(() => {
    if (state.mobileOverlayIsOpen) {
      document.body.classList.add("overflow-hidden")
      // document.body.classList.add("fixed")
    } else {
      document.body.classList.remove("overflow-hidden")
      // document.body.classList.remove("fixed")
    }
  })

  function toggleMobileMenu(e: React.MouseEvent<HTMLElement>) {
    e.preventDefault()
    setState({
      ...state,
      mobileOverlayIsOpen: !state.mobileOverlayIsOpen,
    })
  }

  return (
    <div
      className={cx(
        "inset-0",
        {
          fixed: state.mobileOverlayIsOpen,
        },
        className
      )}
    >
      <header className="relative z-20">
        <div
          className={cx(
            "max-w-screen-lg mx-auto flex justify-between items-center py-6 p-3 sm:pr-6 sm:pl-2",
            {
              "bg-white": state.mobileOverlayIsOpen,
            }
          )}
        >
          <Link to="/">
            <StaticImage
              src="../../../images/LOGO.png"
              alt="cizzgi"
              placeholder="none"
              width={100}
            />
            <Detail className="AvenirLTProBlackOblique text-sm px-2 mt-1">
              Yurt Dışında Yaşayan Kişilerin Hikayeleri
            </Detail>
          </Link>

          <div className="hidden lg:flex">
            <Menu aria-label="Menü" selectionMode="single">
              <Item key="roportajlar" title="Yurt Dışı Röportajları">
                <div className="grid grid-cols-3 gap-x-4">
                  <div>
                    <NavigationLink className="font-bold" to="/roportajlar">
                      Bütün Röportajlar
                    </NavigationLink>
                    <NavigationLink to="/roportajlar/italyada-padova-universitesinde-yuksek-lisans-yapmak">
                      İtalya'da Astrofizik ve Kozmoloji Alanında Yüksek Lisans
                      Yapmak
                    </NavigationLink>
                    <NavigationLink to="/roportajlar/sirketim-iflas-edince-kendimi-almanyada-buldum">
                      Şirketim İflas Edince Kendimi Almanya'da Buldum
                    </NavigationLink>
                    <NavigationLink to="/roportajlar/ogrenciligi-de-is-hayatini-da-japonyada-deneyimlemek">
                      Öğrenciliği de İş Hayatını da Japonya'da Deneyimlemek
                    </NavigationLink>
                    <NavigationLink to="/roportajlar/itu-insaat-fakultesinden-avustralyaya">
                      İTÜ İnşaat Fakültesi'nden 41 Yaşında Avustralya'ya
                    </NavigationLink>
                  </div>
                  <div></div>
                  <div></div>
                </div>
              </Item>

              <Item key="yazilar" title="Yazılar">
                <div className="grid grid-cols-3 gap-x-4">
                  <div>
                    <NavigationLink className="font-bold" to="/yazilar">
                      Bütün Yazılar
                    </NavigationLink>
                    <NavigationLink to="/yazilar/gocmenlik-psikolojisi">
                      Göçmenlik Psikolojisi Hakkında
                    </NavigationLink>
                  </div>
                  <div></div>
                </div>
              </Item>
            </Menu>

            <LinkButton
              to="/iletisim"
              type="primary"
              className="ml-6 text-sm inline-block"
            >
              Hikayeni Paylaş
            </LinkButton>
          </div>

          <button
            aria-label="Menü"
            className={cx(
              "p-1",
              "focus:outline-none",
              "block",
              "lg:hidden",
              className
            )}
            onClick={e => toggleMobileMenu(e)}
          >
            <Hamburger
              fill={"#403C32"}
              width={36}
              height={36}
              isSelected={state.mobileOverlayIsOpen}
            />
          </button>
        </div>
      </header>

      {state.mobileOverlayIsOpen && (
        <div className="block lg:hidden fixed overflow-y-scroll inset-y-0 w-full right-0  py-28 px-4 bg-white z-10">
          <Accordion>
            <Item
              key="roportajlar"
              title="Yurt Dışı Röportajları"
              className="AvenirLTProBlackOblique text-lg"
            >
              <NavigationLink className="font-bold" to="/roportajlar">
                Bütün Röportajlar
              </NavigationLink>
              <NavigationLink to="/roportajlar/italyada-padova-universitesinde-yuksek-lisans-yapmak">
                İtalya'da Astrofizik ve Kozmoloji Alanında Yüksek Lisans Yapmak
              </NavigationLink>
              <NavigationLink to="/roportajlar/sirketim-iflas-edince-kendimi-almanyada-buldum">
                Şirketim İflas Edince Kendimi Almanya'da Buldum
              </NavigationLink>
              <NavigationLink to="/roportajlar/ogrenciligi-de-is-hayatini-da-japonyada-deneyimlemek">
                Öğrenciliği de İş Hayatını da Japonya'da Deneyimlemek
              </NavigationLink>
              <NavigationLink to="/roportajlar/itu-insaat-fakultesinden-avustralyaya">
                İTÜ İnşaat Fakültesi'nden 41 Yaşında Avustralya'ya
              </NavigationLink>
            </Item>
            <Item
              key="yazilar"
              title="Yazılar"
              className="AvenirLTProBlackOblique text-lg"
            >
              <div>
                <NavigationLink className="font-bold" to="/yazilar">
                  Bütün Yazılar
                </NavigationLink>
                <NavigationLink to="/yazilar/gocmenlik-psikolojisi">
                  Göçmenlik Psikolojisi Hakkında
                </NavigationLink>
              </div>
            </Item>
          </Accordion>

          <div className="mt-10 flex justify-center">
            <LinkButton
              to="/iletisim"
              type="primary"
              className="ext-sm inline-block"
            >
              Hikayeni Paylaş
            </LinkButton>
          </div>
        </div>
      )}
    </div>
  )
}

function Menu(props: any) {
  const [state, setState] = useState({
    collection: props.children,
    selectedKeys: [],
  })

  return (
    <ul className={cx(props.className)}>
      {[...state.collection].map(item => (
        <MenuItem
          key={item.key}
          item={item}
          state={state}
          setState={setState}
        />
      ))}
    </ul>
  )
}

function MenuItem({ item, state, setState }: any) {
  const triggerRef = React.useRef() as any
  const bodyRef = React.useRef() as any

  let isSelected = state.selectedKeys.includes(item.key)

  function clearSelection() {
    setState({
      ...state,
      selectedKeys: [],
    })
  }

  function extendSelection(key: any) {
    setState({
      ...state,
      selectedKeys: state.selectedKeys.concat([key]),
    })
  }

  function onMouseEnter(e: React.MouseEvent<HTMLElement>) {
    e.preventDefault()
    clearSelection()
    extendSelection(item.key)
  }

  function onMouseLeave(e: React.MouseEvent<HTMLElement>) {
    e.preventDefault()
    clearSelection()
  }

  function onClick(e: React.MouseEvent<HTMLElement>) {
    e.preventDefault()
    clearSelection()

    if (!isSelected) {
      extendSelection(item.key)
    }
  }

  return (
    <li
      key={item.key}
      ref={triggerRef}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onClick}
      className="inline-block cursor-pointer focus:outline-none"
    >
      <Detail
        className={cx("text-base", "font-bold", "block", "py-3", "px-6", {
          "text-purple": isSelected,
        })}
      >
        <span>
          <span className="align-middle">{item.props.title}</span>
          <Triangle
            fill={isSelected ? "#6D65F3" : "#656575"}
            width={10}
            className="inline-block ml-2 align-middle"
          />
        </span>
      </Detail>
      <Popover
        ref={bodyRef}
        state={state}
        className={cx(
          {
            block: isSelected,
          },
          {
            hidden: !isSelected,
          }
        )}
      >
        <div className="py-10 px-4 text-gray-dark">{item.props.children}</div>
      </Popover>
    </li>
  )
}

const Popover = React.forwardRef(({ className, children }: any, ref: any) => {
  return (
    <div
      ref={ref}
      className={cx(
        "shadow absolute top-17 left-0 right-0 bg-white z-10",
        className
      )}
      // style={{
      //   height: "433px",
      // }}
    >
      <div className="max-w-screen-lg mx-auto p-3">{children}</div>
    </div>
  )
})

function NavigationLink({ to, children, className }: any) {
  return (
    <Link to={to} className={cx("mb-7 block", className)}>
      <Detail className="text-base hover:text-purple">{children}</Detail>
    </Link>
  )
}

export default Header
